import { ChevronLeft, ChevronRight } from "../../assets/icons";
import Button from "../button";
import LogoutNavDesktop from "./navbarComponents/LogoutNavDesktop";
const { dateLong } = require("../../utils/Date");

const NavbarSite = ({ type, dateSelect, setDateSelect }) => {
  const onPrevDateSelect = () => {
    if (dateSelect) {
      const prevDate = new Date(dateSelect);
      prevDate.setDate(prevDate.getDate() - 1);
      setDateSelect(prevDate);
    }
  };

  const onNextDateSelect = () => {
    if (dateSelect) {
      const nextDate = new Date(dateSelect);
      nextDate.setDate(nextDate.getDate() + 1);
      setDateSelect(nextDate);
    }
  };

  return (
    <nav
      className={`py-4 px-8 ${type !== "hourly_tracking" && type !== "activity" ? "border-b border-b-gray-100" : ""}`}
    >
      <div className={"flex justify-between items-center"}>
        <div className={"capitalize"}>
          {type === "hourly_tracking" ? (
            <div className={"flex gap-2.5 items-center"}>
              <div className={"flex gap-1"}>
                <Button
                  color={"SECONDARY"}
                  size={"SMI"}
                  onClick={() => onPrevDateSelect()}
                  name={"header_hourly_tracking_prev_date"}
                >
                    <ChevronLeft wh={16} color={"#374151"} />
                </Button>
                <Button
                  color={"SECONDARY"}
                  size={"SMI"}
                  onClick={() => onNextDateSelect()}
                  name={"header_hourly_tracking_next_date"}
                >
                    <ChevronRight wh={16} color={"#374151"} />
                </Button>
              </div>
              <div
                className={
                  "text-2xl font-semibold header_hourly_tracking_date_display"
                }
              >
                {dateLong(dateSelect)}
              </div>
            </div>
          ) : type === "activity" ? (
            <div className={"text-2xl font-semibold"}>Activité</div>
          ) : (
            <>{dateLong(new Date())}</>
          )}
        </div>
        <LogoutNavDesktop />
      </div>
    </nav>
  );
};

export default NavbarSite;
